export default "__VITE_ASSET__48bc180e__"